import {useState, useRef, useCallback, useEffect} from 'react';
import * as ActionModifiers from '../ActionModifiers';
import * as SizeFunctions from '../utilities/SizeFunctions';
import NormalBtn from '../StockItems/NormalBtn';
import RunOrSimulate from '../RunOrSimulate';
import ColorBar from './ColorBar';
import CoverPage from '../CoverPage';

function App(props) {

  var width = props.width;
  var overallWidth = props.overallWidth;
  var height = props.height;
  var currentSelection = props.currentSelection;
  var templates = props.templates;
  var selectNew = props.selectNew;
  var chains = props.chains;
  var changeTab = props.changeTab;
  var palette = props.palette;

  var ref3 = useRef();

  const [selectionNos, setSelectionNos] = useState(currentSelection);
  const [ownVariablesForTemplate, setOwnVariablesForTemplate] = useState({})
  const [colorCombo, setColorCombo] = useState(0);
  const [counter, setCounter] = useState(0);
  const [navBarHeight, setNavBarHeight] = useState(0);

  function incrementCounter(){
    setCounter(counter + 1);
  }

  var cust = ActionModifiers.createNull();  
  const [customColorRecord, setCustomColorRecord] = useState(cust);
  const [isShowingCustom, setIsShowingCustom] = useState(false);


  const handleUserKeyPress = useCallback(event => {
      const { keyCode } = event;
      if (keyCode === 37){
        doPrevious();
      }else if (keyCode === 39){
        doNext();
      }
  }, [selectionNos, counter]);


  useEffect(() => {
      window.addEventListener('keydown', handleUserKeyPress);
      return () => {
          window.removeEventListener('keydown', handleUserKeyPress);
      };
  }, [handleUserKeyPress]);

  if (selectionNos < 0){
    return null;
  }

  var thisTemplate = templates[selectionNos];
  var cListCleaned = JSON.parse(JSON.stringify(thisTemplate.c));

  var components = ActionModifiers.getColorComponents(isShowingCustom, customColorRecord, palette, colorCombo);
  var modOptions = ActionModifiers.findIssues(cListCleaned, components, 'selectNew', chains, changeTab);

  var styleTD;
  var cut = 10;
  var botHeight = height - navBarHeight - 100;
  if (modOptions.length > 0){
    cut = 210;
    styleTD = <ColorBar colorCombo={colorCombo} setColorCombo={setColorCombo} incrementCounter={incrementCounter}  customColorRecord={customColorRecord} setCustomColorRecord={setCustomColorRecord} isShowingCustom={isShowingCustom} setIsShowingCustom={setIsShowingCustom} modOptions={modOptions} palette={palette} counter={counter} height={botHeight}/>

  }
//  

  function clickSelect(e){
    selectNew(thisTemplate.i, cListCleaned);
  }

  function doPrevious(){
    if (selectionNos > 0){
      setSelectionNos(selectionNos - 1);
    }else{
      setSelectionNos(templates.length - 1);
    }
    incrementCounter();
  }

  function clickPrevious(e){
    doPrevious();
  }

  function doNext(){
    if (selectionNos < templates.length - 1){
      setSelectionNos(selectionNos + 1);
    }else{
      setSelectionNos(0);
    }
    incrementCounter();
  }
  function clickNext(e){
    doNext();
  }

  var offsetLeft = width * 0.1;
  var offsetTop = 0;
  if (ref3 && ref3.current){
    offsetLeft += ref3.current.offsetLeft;
    offsetTop = ref3.current.offsetTop;
  }

  var navContents = <div style={{padding:'20px'}}><NormalBtn icon='fluent:previous-24-filled' title='Previous' onClick={clickPrevious} />
      <NormalBtn icon='mdi:rocket-launch-outline' title='Select' onClick={clickSelect} />
      <NormalBtn icon='fluent:next-24-filled' title='Next' onClick={clickNext} /></div>
//
  return <div style={{padding:'10px', paddingTop:'0px', width}}>
      <CoverPage contents={navContents} reportHeight={SizeFunctions.updateSubsetDimensions(setNavBarHeight)} />
      <table><tbody><tr>
        <td style={{verticalAlign:'top'}}><div ref={ref3}>
        <RunOrSimulate chains={chains} currentList={cListCleaned} overallWidth={overallWidth} width={width - cut} height={botHeight} overlays={null} programSetID={counter} ownVariables={ownVariablesForTemplate} setOwnVariables={setOwnVariablesForTemplate} urlParamsForExecution={''} urlHeader='https://www.cues.sg/dapps/XXXX' run={false} offsetTop={offsetTop} offsetLeft={offsetLeft}/>
        </div></td>
        {styleTD}
      </tr></tbody></table>
    </div>
}


export default App;
